import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newCategoryProductSchema } from '@/shared';
import {
  useCreateCategoryProduct,
  useUpdateCategoryProduct,
} from '@/shared/actions/erp';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { CATEGORYPRODUCT } from '@/shared/interfaces/erp/inventario';


const returnUrlCategoryProducto = '/inventario/categoria-productos';

export interface SaveCategoryProductInterface {
  titlePage: string;
  editCategoryProduct?: CATEGORYPRODUCT;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  estado: boolean;
};

const SaveCategoryProduct: React.FC<SaveCategoryProductInterface> = ({
  titlePage,
  editCategoryProduct,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createCategoryProductMutation = useCreateCategoryProduct({
    navigate,
    returnUrl:returnUrlCategoryProducto
});
  const updateCategoryProductMutation = useUpdateCategoryProduct({
    navigate,
    returnUrl:returnUrlCategoryProducto
  });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCategoryProductSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;



  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editCategoryProduct?.id_categoria_producto) {
      return updateCategoryProductMutation.mutate({
        id: editCategoryProduct.id_categoria_producto,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCategoryProductMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCategoryProduct) {
      setShrink(true);
      reset(editCategoryProduct as any);
    }
  }, [editCategoryProduct]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCategoryProducto);
      }}
      onSave={handleSubmit(onSave)}
    >
        <CustomTextField
              name="codigo"
              label="Codigo"
              control={form.control}
              defaultValue={form.getValues().codigo || ""}
              error={errors.codigo}
              helperText={errors.codigo?.message}
              shrink={shrink}
            />
      <CustomTextField
              name="nombre"
              label="Nombre"
              control={form.control}
              defaultValue={form.getValues().nombre || ""}
              error={errors.nombre}
              helperText={errors.nombre?.message}
              shrink={shrink}
            />
      
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveCategoryProduct;
